import React, { useState, useEffect } from 'react';
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import IntroVideo from "./components/IntroVideo";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import BookAppointmentPage from "./pages/BookAppointmentPage";
import AdminDashboard from "./pages/AdminDashboard";

function AppContent() {
  const [showIntro, setShowIntro] = useState(true);
  const location = useLocation();

  // Don't show intro on admin page
  const isAdminPage = location.pathname.startsWith('/admin');

  useEffect(() => {
    if (isAdminPage) {
      setShowIntro(false);
    }
  }, [isAdminPage]);

  const handleIntroComplete = () => {
    setShowIntro(false);
  };

  return (
    <>
      {showIntro && !isAdminPage && <IntroVideo onComplete={handleIntroComplete} />}
      
      <div className={`transition-opacity duration-500 ${showIntro && !isAdminPage ? 'opacity-0' : 'opacity-100'}`}>
        <Routes>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/book" element={<BookAppointmentPage />} />
          </Route>
        </Routes>
      </div>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
